package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.*
import ru.villawonka.app.domain.repository.PostsRepository

class RequestPostByIdUseCase(
    private val postsRepository: PostsRepository,
) {

    suspend operator fun invoke(
        postId: Int,
        postType: PostTypeDomain
    ): Either<NetworkFailure, PostDomain> =
        when (postType) {
            PostTypeDomain.ACCOMMODATION -> postsRepository.requestAccommodationPostById(postId)
            PostTypeDomain.MONEY_EXCHANGE,
            PostTypeDomain.VISA_AGENCY,
            PostTypeDomain.TRANSPORT -> throw NotImplementedError()
        }
}